// @flow

import * as React from 'react';
import Group from 'sail/Group';
import Box from 'sail/Box';
import {Button} from 'sail/Button';
import classNames from 'classnames';
import './ImageGroup.scss';
import ModalLayer from 'sail/ModalLayer';
import {Video} from 'docs/components';

import type {BackgroundColor} from 'sail/Box/types';
import {FormattedMessage} from 'react-intl';

const VideoButton = ({src}) => {
  const [zoomed, setZoomed] = React.useState(false);

  return (
    <Box padding={{top: 24, right: 48}}>
      <Button
        onClick={() => {
          setZoomed(true);
        }}
        color="white"
        size="large"
        className="VideoButton"
        label={
          <FormattedMessage
            id="docsShell.imageGroup.watchVideoButton"
            description="Button label used when launching a video player"
            defaultMessage="Watch video"
          />
        }
      />
      <ModalLayer
        shown={zoomed}
        onWashClick={() => setZoomed(false)}
        onEscape={() => setZoomed(false)}
      >
        <Video type="video/mp4" src={src} width="70%" />
      </ModalLayer>
    </Box>
  );
};

type ImageGroupProps = {|
  id?: string,
  className?: string,
  children?: React.Node,
  background?: BackgroundColor,
  video?: string,
|};

export const ImageGroup = ({
  id,
  className,
  children,
  background,
  video,
}: ImageGroupProps) => (
  <Box
    background={background}
    style={video ? {textAlign: 'right'} : {}}
    margin={{top: 16}}
  >
    {video && <VideoButton src={video} />}
    <Group
      id={id}
      className={classNames('ImageGroup', className)}
      direction="horizontal"
      justifyContent="space-around"
      alignItems="baseline"
      spacing={16}
    >
      {children}
    </Group>
  </Box>
);
